import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Red de seguridad raíz: sin esto, cualquier excepción durante el render deja
 * `<div id="root">` completamente vacío (pantalla en blanco sin ningún
 * mensaje) — es el comportamiento por defecto de React cuando nadie captura
 * el error. Con este componente, en su lugar se muestra un mensaje y un
 * botón para recargar.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error('[ErrorBoundary] Error de render no capturado:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            padding: '24px',
            textAlign: 'center',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <h1 style={{ fontSize: '20px', fontWeight: 600, color: '#1f2937' }}>
            Algo salió mal
          </h1>
          <p style={{ color: '#6b7280', maxWidth: '32rem' }}>
            Ocurrió un error inesperado al cargar esta pantalla. Intenta recargar la página; si el
            problema sigue, avisa al equipo técnico.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              borderRadius: '8px',
              border: 'none',
              background: '#1565D8',
              color: '#fff',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Recargar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
